export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9082.fe9df96d.jpg";